import { render } from "./ModulesSlug.vue?vue&type=template&id=ae7186cc"
import script from "./ModulesSlug.vue?vue&type=script&lang=js"
export * from "./ModulesSlug.vue?vue&type=script&lang=js"

import "./ModulesSlug.vue?vue&type=style&index=0&id=ae7186cc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__